import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminAffiliates = lazy(() => import("@/pages/admin/AdminAffiliates"));

export const Route = createFileRoute("/admin/affiliates")({
  component: AdminAffiliates,
});
